import React from 'react';
import { useSelector } from 'react-redux';
import ItemBlock from '../../itemBlock/ItemBlock';
import classes from './HowToPlayBlock.module.css';

const HowToPlayBlock = ({ title, leftCard, rightText }) => {
  
  const { texts, lang } = useSelector(state => state.translate);

  return (
    <ItemBlock title={texts[title] || title}>
      <div className={classes.Wrapper}>
        <div className={classes.textSection}>
          {rightText?.intro &&
            <p className={classes.intro} dangerouslySetInnerHTML={{ __html: texts[rightText.intro] || rightText.intro }}></p>
          }
          {rightText?.items && rightText.items.map((item, index) => (
            <p key={index} className={classes.textItem}>
              {item?.title &&
                <span className={classes.itemTitle}>{texts[item.title] || item.title} </span>
              }
              {item?.text &&
                <span className={classes.itemText} dangerouslySetInnerHTML={{ __html: texts[item.text] || item.text }}></span>
              }
            </p>
          ))}
        </div>
        {leftCard && <img src={leftCard.src[lang]} alt={leftCard.alt || ''} className={classes.leftCard} />}
      </div>
    </ItemBlock>
  );
};

export default HowToPlayBlock;
